module.exports = __webpack_public_path__ + "static/media/blue-down-arrow.6037f379.svg";